import React, { ReactNode } from 'react';

interface CardProps {
  title?: string;
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
  variant?: 'default' | 'elevated' | 'bordered' | 'gradient' | 'glass';
}

const Card: React.FC<CardProps> = ({ 
  title, 
  children, 
  className = '', 
  footer,
  variant = 'default'
}) => {
  // Define variant-specific classes
  const variantClasses = {
    default: 'bg-background-card border border-card-border shadow-card',
    elevated: 'bg-background-card border border-indigo-800/30 shadow-lg shadow-indigo-900/10',
    bordered: 'bg-background-card/70 backdrop-blur-sm border-2 border-indigo-800/40 shadow-sm',
    gradient: 'bg-gradient-to-br from-gray-900/90 via-indigo-900/20 to-transparent border border-indigo-800/20 shadow-lg',
    glass: 'bg-black/40 backdrop-blur-md border border-indigo-800/30 shadow-xl'
  };

  return (
    <div 
      className={`card ${variantClasses[variant]} transition-all duration-300 hover:shadow-card-hover rounded-xl ${className} relative overflow-hidden`}
    >
      {/* Subtle background pattern overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(99,102,241,0.05)_1px,transparent_1px)] bg-[length:24px_24px] opacity-20 pointer-events-none"></div>
      
      {title && (
        <div className="mb-4 pb-2 border-b border-indigo-800/30">
          <h3 className="text-lg font-medium bg-clip-text text-transparent bg-gradient-to-r from-blue-200 to-indigo-300">{title}</h3>
        </div>
      )}
      
      <div className="relative z-10">
        {children}
      </div>
      
      {footer && (
        <div className="mt-4 pt-3 border-t border-indigo-800/30 bg-gradient-to-r from-transparent via-indigo-900/10 to-transparent">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card; 